/**
 * Display name for a user record: "First Last" when available, else username, else email.
 */
export const formatUserDisplayName = (user) => {
  if (!user) return '';
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  if (fullName) return fullName;
  if (user.username) return user.username;
  return user.email || '';
};

/**
 * Resolve a display name from an email using a list of user records.
 * Falls back to the email when no matching user is found.
 */
export const resolveUserDisplayNameByEmail = (email, usersList = []) => {
  if (!email) return '';
  const normalized = String(email).toLowerCase();
  const match = usersList.find((u) => (u.email || '').toLowerCase() === normalized);
  return match ? formatUserDisplayName(match) : email;
};

/**
 * Resolve a display name from a user id using a list of user records.
 * Falls back to the id string when no matching user is found.
 */
export const resolveUserDisplayNameById = (userId, usersList = []) => {
  if (!userId) return '';
  const match = usersList.find((u) => u.id === userId);
  if (!match) return String(userId);
  return formatUserDisplayName(match) || match.email || String(userId);
};
